import { render } from "./DriverLicenseCategories.vue?vue&type=template&id=7b5d11b9&scoped=true"
import script from "./DriverLicenseCategories.vue?vue&type=script&lang=js"
export * from "./DriverLicenseCategories.vue?vue&type=script&lang=js"

import "./DriverLicenseCategories.vue?vue&type=style&index=0&id=7b5d11b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5d11b9"]])

export default __exports__